import { render, staticRenderFns } from "./device-list3.vue?vue&type=template&id=654fd93d&scoped=true"
import script from "./device-list3.vue?vue&type=script&lang=js"
export * from "./device-list3.vue?vue&type=script&lang=js"
import style0 from "./device-list3.vue?vue&type=style&index=0&id=654fd93d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654fd93d",
  null
  
)

export default component.exports